import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { AuthContext } from 'context/AuthContext';

const AccionesCellDetalles = ({ onEditDetalles, onDeleteDetalles }) => {
  const { hasRole } = useContext(AuthContext);
  const isClient = hasRole?.('client') === true;   // por si hasRole no existe aún

  // Si es cliente, no renderiza nada
  if (isClient) return null;

  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      <IconButton aria-label="editar" color="info" onClick={onEditDetalles}>
        <EditIcon />
      </IconButton>
      <IconButton aria-label="eliminar" color="error" onClick={onDeleteDetalles}>
        <DeleteIcon />
      </IconButton>
    </div>
  );
};

AccionesCellDetalles.propTypes = {
  onEditDetalles: PropTypes.func.isRequired,
  onDeleteDetalles: PropTypes.func.isRequired,
};

export default AccionesCellDetalles;
